var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/MediaVideoList/MediaVideoListInner.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/MediaVideoList/MediaVideoListInner.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
frame = frame.push();
var t_6 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"list");
if(t_6) {t_6 = runtime.fromIterator(t_6);
var t_5 = t_6.length;
for(var t_4=0; t_4 < t_6.length; t_4++) {
var t_7 = t_6[t_4];
frame.set("item", t_7);
frame.set("loop.index", t_4 + 1);
frame.set("loop.index0", t_4);
frame.set("loop.revindex", t_5 - t_4);
frame.set("loop.revindex0", t_5 - t_4 - 1);
frame.set("loop.first", t_4 === 0);
frame.set("loop.last", t_4 === t_5 - 1);
frame.set("loop.length", t_5);
output += "\n    <li class=\"MediaVideoListInner-item MediaVideoListInner-item--";
if(runtime.memberLookup((t_7),"sourcesCount") < 2) {
output += "single";
;
}
else {
output += "playlist";
;
}
output += "\" ";
if((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"isInitial"))) {
output += "data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\"";
;
}
output += ">\n        <a href=\"";
output += runtime.suppressValue(runtime.memberLookup((t_7),"url"), env.opts.autoescape);
output += "\">\n            <div class=\"MediaVideoListInner-itemPreview\">\n                <div class=\"MediaVideoListInner-itemPreviewWrapper\">\n                    <img src=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_7),"cover")),"w560_url"), env.opts.autoescape);
output += "\"\n                    srcset=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_7),"cover")),"w680_url"), env.opts.autoescape);
output += " 2x\"\n                    alt=\"\">\n                </div>\n                <div class=\"MediaVideoListInner-itemBtnPlayWrapper\">\n                    <div class=\"MediaVideoListInner-itemBtnPlay\"></div>\n                </div>\n            </div>\n            <div class=\"MediaVideoListInner-itemTitle\">\n                ";
output += runtime.suppressValue(runtime.memberLookup((t_7),"title"), env.opts.autoescape);
output += "\n            </div>\n            <div class=\"MediaVideoListInner-itemInfo\">\n                ";
if(runtime.memberLookup((t_7),"sourcesCount") < 2) {
output += "\n                    ";
if(runtime.memberLookup((t_7),"duration")) {
output += runtime.suppressValue(runtime.memberLookup((t_7),"duration"), env.opts.autoescape);
;
}
output += "\n                ";
;
}
else {
output += "\n                    ";
output += runtime.suppressValue(runtime.memberLookup((t_7),"sourcesCount"), env.opts.autoescape);
output += "&nbsp;videos\n                ";
;
}
output += "\n            </div>\n        </a>\n    </li>\n";
;
}
}
frame = frame.pop();
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/MediaVideoList/MediaVideoListInner.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MediaVideoList/MediaVideoListInner.jinja
// module id = 97
// module chunks = 0